import { Card, CardBody, Col } from "reactstrap";
import { Btn, H6, Image, LI, P, UL } from "../../../../../AbstractElements";
import { Href, TopUsersTitle } from "../../../../../Constants/Constants";
import DashboardCommonHeader from "../../../../CommonComponents/DashboardCommonHeader/DashboardCommonHeader";
import { dynamicImage } from "../../../../../Utils";
import { Link } from "react-router-dom";
import SvgIcon from "../../../../CommonComponents/SvgIcon/SvgIcon";
import { TopUsersData } from "../../../../../Data/General/Dashboard/Default";

const TopUsers = () => {
  return (
    <Col xl="4" md="6">
      <Card>
        <DashboardCommonHeader title={TopUsersTitle} dropdownClass="dropdown-toggle" />
        <CardBody className="top-user custom-scrollbar">
          <UL className="custom-scrollbar simple-list">
            {TopUsersData.map((data, index) => (
              <LI className="d-flex align-items-center justify-content-between gap-2" key={index}>
                <div className="d-flex gap-2 align-items-center">
                  <div className="flex-shrink-0 comman-round">
                    <Image src={dynamicImage(data.image)} alt="" />
                  </div>
                  <div>
                    <Link to={Href}><H6>{data.title}</H6></Link>
                    <P><SvgIcon className="stroke-icon" iconId="map-icon" />Texas</P>
                  </div>
                </div>
                <span>{data.price}</span>
                <Btn color="transparent" className={`bg-light-${data.color} border-light-${data.color} text-${data.color}`}>{data.button}</Btn>
              </LI>
            ))}
          </UL>
        </CardBody>
      </Card>
    </Col>
  );
};

export default TopUsers;
